/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.4.0
 * @since 1.0.0
 */

import styled from 'styled-components';

import { fonts } from '../../../theme';

const ErrorPageStyled = styled.div.attrs({
    className: 'error-page',
})`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 7.7%;

    & .error-page__description {
        max-width: 760px;
        margin-top: 1.6%;
        text-align: center;
    }
`;

const ErrorPageImgContainerStyled = styled.div.attrs({
    className: 'error-page__img-container',
})`
    width: 360px;
    height: 304px;
    margin-bottom: 48px;
`;

const ErrorPageImgStyled = styled.img.attrs({
    className: 'error-page__img',
})`
    height: 100%;
`;

const ErrorPageTitleStyled = styled.span.attrs({
    className: 'error-page__title',
})`
    ${fonts.textHeader2}
`;

const ErrorPageDescriptionStyled = styled.span.attrs({
    className: 'error-page__description',
})`
    ${fonts.textMain}
`;

export {
    ErrorPageDescriptionStyled,
    ErrorPageImgContainerStyled,
    ErrorPageImgStyled,
    ErrorPageStyled,
    ErrorPageTitleStyled,
}
